<template>
    <div>
        <div class="delaer-info" v-for="(item,i) in data" :key="i"  @click="show?routerLink(item.member_id):''">
            <div class="delaer-iphone van-ellipsis" :style="{'justify-content':type}">
                {{item.mobile}}
            </div>
            <div class="delaer-heavy-currency van-ellipsis">
                重消币:{{item.consum_point}}
                <img v-show="show" src="../assets/localImage/Arrow right.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props:{
            data:{
                type: Array,
                default:()=>[]
            },
            type:{
                type:String,
                default:''
            },
            show:{
                type:Boolean,
                default: true
            }
        },
        methods:{
            routerLink(memberId){
                this.$router.push({
                    path:"/DealerDetails",
                    query:{
                        member_id:memberId
                    }
                });
            }
        }
    }
</script>
<style scoped>
    .delaer-info{
        display: flex;
        height: 90px;
        background-color: #fff;
        padding: 0 43px;
        overflow: hidden;
        justify-content: space-between;
    }
    .delaer-info:nth-child(2n+2){
        background-color: #FAFAFA;
    }
    .delaer-iphone{
        width: 240px;
        text-align: center;
        font-size:26px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:37px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .delaer-heavy-currency{
        text-align: center;
        font-size:26px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:37px;
        display: flex;
        justify-content: left;
        align-items: center;
    }
    .delaer-heavy-currency>img{
        width: 12px;
        height: 22px;
        margin-left: 34px;
    }
</style>